module.exports = __webpack_public_path__ + "img/coock.ac403401.jpg";